/**
 * * Модель запроса на создание рабочего пространства
 */
export default class ProjectNamespaceCreateRequest  {
	/**
	 * * Ид проекта
	 */
	ProjectId!: number;
	/**
	 * * Название
	 */
	Name!: string;
	/**
	 * * Номер иконки
	 */
	IconId!: string;
	/**
	 * * Номер цвета
	 */
	ColorId!: string;
	/**
	 * * Список администраторов рабочего пространства
	 */
	AdminIds!: Array<number>;
	/**
	 * * Номера команды
	 */
	EmployeeIds!: Array<number>;
	constructor(obj?: Partial<ProjectNamespaceCreateRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
